<script setup lang="ts">
  import type { ExitIntentContext } from '~/composables/ExitIntent'

  const props = defineProps<{
    id: string
    context: ExitIntentContext
  }>()

  const {
    content,
    selections,
    feedback,
    onSubmit,
    onViewed,
    options,
    showCarrierInput,
    followUpModalContent
  } = await ExitIntent.use(props.context, props.id)
</script>

<template>
  <HpModal :title="content.ext.title" :id="id" @show="onViewed" no-padding>
    <div class="-mt-2 mb-6 flex w-full justify-center text-xl font-normal text-gray-800">
      {{ content.ext.subheader }}
    </div>
    <HpForm :id="`${id}-form`" class="flex w-full flex-col items-start">
      <HpFormCheckboxGroup :label="content.ext.question_text" v-model="selections" :options />
      <HpFormInput
        class="mt-4 w-full"
        :label="content.ext.feedback_prompt"
        v-model="feedback"
        placeholder="Feedback"
      />
    </HpForm>
    <template #footer>
      <HpButton variant="primary" @click="onSubmit" class="mt-5">Submit</HpButton>
    </template>
  </HpModal>

  <ExitIntentFollowUpModal
    :content="followUpModalContent"
    :show-carrier-input="showCarrierInput"
    :id="id"
    :context="context"
  />
</template>

<style scoped>
  :deep(.form-check span) {
    @apply text-start;
  }
</style>
